import React, { useRef, useState } from 'react';
import ReactCrop, { Crop } from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import DraggableModal from 'src/app/components/DraggableModal/DraggableModal';

import styles from './MapCropper.module.scss';
import { defaultCropParameters, getCroppedImage, MapCropperPropTypes } from './map-cropper.config';

const MapCropper: React.FC<MapCropperPropTypes> = ({ active, setActive, imageUrl }) => {
  const mapImageRef = useRef<HTMLImageElement>(null);

  const [croppedMapImage, setCroppedMapImage] = useState<Crop>(defaultCropParameters);

  return active && imageUrl.length > 0 ? (
    <DraggableModal
      id="cropMap"
      headerText="CROP MAP"
      onClickClose={() => setActive(false)}
      className={styles.drag}
      position={{ x: -180, y: -60 }}
      contentClassName={styles.wrapper}
    >
      <div className={styles.popupMainContainer}>
        <div className={styles.popupContainer}>
          <div className={styles.content}>
            <ReactCrop crop={croppedMapImage} onChange={(c) => setCroppedMapImage(c)}>
              <img ref={mapImageRef} src={imageUrl} alt="Crop Map" className={styles.cropImage} />
            </ReactCrop>
          </div>
        </div>
      </div>

      <div className="popup-footer command-buttons">
        <div>
          <div>
            <button className="next-button" onClick={() => getCroppedImage(mapImageRef, croppedMapImage)} type="submit">
              SAVE
            </button>
            <button className="modal-button" onClick={() => setActive(false)} type="button">
              CANCEL
            </button>
          </div>
        </div>
      </div>
    </DraggableModal>
  ) : null;
};

export default MapCropper;
